export default __webpack_public_path__ + "static/media/giveon.6f20375e.jpeg";